import './index.scss';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import { userInfo } from '../../../redux/slice';
import { useSelector } from 'react-redux';

export default CoverLetter; function CoverLetter({ Template, VotingDetails }) {
    const history = useHistory();
    const user = useSelector(userInfo);
    const { t } = useTranslation();
    function goDetail(url) {
        history.push({
            pathname: url
        });
    }

    const hasMissingInfo = (VotingDetails.citizenship === '' || VotingDetails.residencyID === '' || VotingDetails.taxFilingOption === ''
        || (VotingDetails.usaResident === 'Resident' && VotingDetails.usStateName === '')
        || ((VotingDetails.citizenship === 'United States' || VotingDetails.residencyID === 'United States') && VotingDetails.usaResident === 'Non-Resident'));

    return (
        <>
            <div id="stepper-cover-letter-div">
                <div className='row stepper-p cover-letter-content col-md-12'>
                    <div className='template' dangerouslySetInnerHTML={{ __html: Template }} />
                    {
                        Template !== '' && (<>
                            <div className='coverletter-notes'>
                                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M24 44C12.9735 44 4 35.0107 4 23.9563C4 12.902 12.9735 4 24 4C35.0265 4 44 12.9551 44 23.9563C44 34.9576 35.0265 44 24 44ZM24 7.68985C15.0038 7.68985 7.68182 14.986 7.68182 23.9563C7.68182 32.9266 15.0038 40.3101 24 40.3101C32.9962 40.3101 40.3182 32.976 40.3182 23.9563C40.3182 14.9367 33 7.68985 24 7.68985V7.68985Z" fill={hasMissingInfo ? "#cc0202" : "#4650C9"} />
                                    <path d="M23.8371 33.0166C22.8241 33.0166 22 32.189 22 31.1716V23.4465C22 22.4291 22.8241 21.6016 23.8371 21.6016C24.8502 21.6016 25.6742 22.4291 25.6742 23.4465V31.1716C25.6742 32.189 24.8502 33.0166 23.8371 33.0166Z" fill={hasMissingInfo ? "#cc0202" : "#4650C9"} />
                                    <path d="M23.8371 19.7981C22.8241 19.7981 22 18.9705 22 17.9532V16.8371C22 15.8197 22.8241 14.9922 23.8371 14.9922C24.8502 14.9922 25.6742 15.8197 25.6742 16.8371V17.9532C25.6742 18.9705 24.8502 19.7981 23.8371 19.7981Z" fill={hasMissingInfo ? "#cc0202" : "#4650C9"} />
                                </svg>
                                {
                                    hasMissingInfo ? <span className='missing-profile'>{t('Update_Profile_Notes_HasMissing_Info')}</span> : <span className='update-profile'>{t('Update_Profile_Notes')}</span>
                                }
                                <button className='update-profile-button' onClick={() => { goDetail(user.sfUserType === 'IR' ? '/preview/profile' : '/profile') }}>{t('UPDATE PROFILE')}</button>
                            </div>
                        </>)
                    }
                </div>
            </div>
        </>
    );
}